export class Settings {
  [key: string | number]: any;
  language!: string;
  loginToken!: string;
  distributorDomain!: string;
  distributorDomainConfigurable!: boolean;
  fromMail!: string;
  fromMailConfigurable!: boolean;
  sendPasswordEmail!: boolean;
  sendPasswordEmailConfigurable!: boolean;
  login!: {
    form: {
      position: 'left' | 'center' | 'right';
      backgroundColor: 'black' | 'white';
    }
    header: {
      backgroundColor: 'transparent' | 'black' | 'white';
    }
    wallpaper: {
      background: 'color' | 'image';
      backgroundColor: string;
      backgroundImage: string;
    }
  }

  layout!: {
    sidebar: {
      background: 'color' | 'image';
      color: 'black' | 'white';
      backgroundColor: string;
      backgroundImage: string;
    }
  }

  dashboard?: {
    card: {
      headerColor: string | null;
      outlineColor: string | null;
      mimesys: {
        headerLogoImage: string | null;
        bodyImage: string | null;
      };
      fit: {
        headerLogoImage: string | null;
        bodyImage: string | null;
      };
      depict360: {
        headerLogoImage: string | null;
        bodyImage: string | null;
      };
    };
    allowConfigure: boolean;
  }

  logo!: {
    1: {
      image: string;
      configurable: boolean;
      default?: string;
    }
    2: {
      image: string;
      configurable: boolean;
      default?: string;
    }
    3: {
      image: string;
      configurable: boolean;
      default?: string;
    }
    4: {
      image: string;
      configurable: boolean;
      default?: string;
    }
    5: {
      image: string;
      configurable: boolean;
      default?: string;
    }
    6: {
      image: string;
      configurable: boolean;
      default?: string;
    }
  }
}

export class SettingsFitMade4U {
  language!: string;
  fittingHeight!: string;
  limitedBandwidth!: boolean;
  appFrontendDesign!: {
    fit?: {
      logoImage?: string | null;
      logoName?: string | null;
      appName: string;
      logoChanged?: boolean;
    }
    m4u?: {
      logoImage?: string;
      logoName?: string;
      appName: string;
      logoChanged?: boolean;
    },
    logo1?: {
      logoImage?: string;
      logoName?: string;
      allowConfiguration?: boolean;
    },
    logo2?: {
      logoImage?: string;
      logoName?: string;
    },
  };
  dataProtection!: {
    dataProcessor: string;
    opticalShopName: string;
    opticalShopEmail: string;
    allowDelete: boolean;
  }
  screenSaver!: {
    enabled?: boolean;
    fileName?: string | null;
    mimeType?: string | null;
    size?: number | null;
  };
  screenSaverVideo?: any;
  screenSaverVideoData?: string;
  technologies!: {
    boxIA: boolean;
    corridor: boolean,
    nearpd: boolean
  };
  externalReporting!: {
    service: string;
    enabled?: boolean;
    params: {
      userId: string;
    }
  };
  catalogs!: {
    BASICSHAPES: boolean;
    MIMIC_2017_2018: boolean;
    "LIQ-RX_2019": boolean;
    LIQ_2019: boolean;
  };
  managementOrders!: {
    specialRates: {
      uniformity: boolean,
      vip: boolean
    },
    reminderEmail: string,
    validatorEmail: string
  };
  shippingAddress!: {
    country: string;
    address: string;
    cityAndZipCode: string;
  };
  timezone?: string;
}

export class Settings360Depict {
  language!: string;
  appFrontendDesign?: {
    "360Depict"?: {
      logoImage?: string;
      logoName?: string;
      appName: string;
    };
  };
  technologies?: {
    thinmaxPositive: {
      name: string;
      enabled: boolean
    },
    thinmaxNegative: {
      name: string;
      enabled: boolean
    },
    extremePrescriptions: {
      name: string;
      enabled: boolean
    },
    highPrescriptions: {
      name: string;
      enabled: boolean
    },
    curvedStyle: {
      name: string;
      enabled: boolean
    },
  };
}

export class previewSettings {
  app!: string;
  logoA?: string;
  fitName?: string;
  logoB?: string;
  m4uName?: string;
  logoC?: string;
  depictName?: string;
  logo1?: string;
  logo2?: string;
}

export class SettingsMimesys {
  [key: string | number]: any;
  entityId?: number;
  parentEntityId?: number;
  language?: string;
  appUser?: string;
  appPwd?: string;
  template?: string;
  color?: string;
  onlyVisibleBy?: boolean;
  // progresiveMidName?: string;
  // progresiveTopName?: string;
  // progresiveBasicName?: string;
  environments_3d!: {
    lp_environment_id?: any;
    lo_environment_id?: any;
    cp_environment_id?: any;
    co_environment_id?: any;
    ls_environment_id?: any;
    launcher_environment_id?: any;
    comparison_environment_id?: any;
  }
  externalReporting?: {
    service?: string;
    enabled?: boolean;
  }
  logo1Default?: string;
  logo1Parent?: boolean;
  logo3Default?: string;
  logo3Parent?: boolean;
  externalRequest?: {
    enabled?: boolean;
    requestToken?: string;
  };
  shortTestID?: boolean;
  ergoCorridorEnable?: boolean;
  ergoCorridorName?: string;
  ergoCorridorLogoParent?: boolean;
  ergoCorridorLogoDefault?: string;
  videoEnable?: boolean;
  videoFileParent?: boolean;
  videoFileDefault?: string;
  mapsDisplay?: string;
  gazeType?: boolean;
  amplitudeRatio?: boolean;
  maxFrequencyVector?: boolean;
  diagnostic?: boolean;
  additionalMapsDisplay?: string;
  timezone?: string;
  appFrontendDesign!: {
    logo1?: {
      logoImage?: string;
      logoName?: string;
      allowConfiguration?: boolean;
    },
    logo2?: {
      logoImage?: string;
      logoName?: string;
    },
    logo3?: {
      logoImage?: string;
      logoName?: string;
      allowConfiguration?: boolean;
    },
    distributorLogo?: {
      logoImage?: string;
      logoName?: string;
      allowConfiguration?: boolean;
    },
    mimesysProductLogo?: {
      logoImage?: string;
      logoName?: string;
    },
    lensLogo?: {
      logoImage?: string;
      logoName?: string;
    },
    coachLogo?: {
      logoImage?: string;
      logoName?: string;
    },
    progressiveLogo?: {
      logoImage?: string;
      logoName?: string;
    },
    officeLogo?: {
      logoImage?: string;
      logoName?: string;
    },
    svisionLogo?: {
      logoImage?: string;
      logoName?: string;
    },
    progressiveLogoSubmenu?: {
      logoImage?: string;
      logoName?: string;
    },
    officeLogoSubmenu?: {
      logoImage?: string;
      logoName?: string;
    },
    svisionLogoSubmenu?: {
      logoImage?: string;
      logoName?: string;
    },
    ergoCorridorLogo?: {
      logoImage?: string;
      logoName?: string;
    },
    coverImage?: {
      logoImage?: string;
      logoName?: string;
    },
    insidePageImage?: {
      logoImage?: string;
      logoName?: string;
    },
  };
  screenSaver!: {
    enabled?: boolean;
    fileName?: string | null;
    mimeType?: string | null;
    size?: number | null;
  };
  screenSaverVideo?: any;
  screenSaverVideoData?: string;
  screenSaverEnabled?: boolean;
}

export interface MimesysConfigInterface {
  [key: string | number]: any;
}
export class MimesysConfigClass {
  public constructor(public config: MimesysConfigInterface) {
    // copy options to instance's fields here
  }
}
export const mimesysConfig = new MimesysConfigClass({

  logos: [
    'distributorLogo',
    'mimesysProductLogo',
    'lensLogo',
    'coachLogo',
    'progressiveLogo',
    'officeLogo',
    'svisionLogo',
    'progressiveLogoSubmenu',
    'officeLogoSubmenu',
    'svisionLogoSubmenu',
    'logo1',
    'logo2',
    'logo3',
    'coverImage',
    'insidePageImage'
  ],
  appsAbrev: [
    { id: 1, typeId: 1, abrev: 'LP' },
    { id: 3, typeId: 3, abrev: 'LO' },
    { id: 2, typeId: 2, abrev: 'CP' },
    { id: 4, typeId: 4, abrev: 'CO' },
    { id: 8, typeId: 8, abrev: 'LS' }
  ],
  /*packageTypes: [
    { id: 1, value: 'Essential', apps: ["LP"], appsTypeId: [1], preview: 'welcome-Preview-B.png', previewImgSubmenu: '', previewDesk: 'desk-Preview-A.png', layout: 'welcome-Layout-B.png', layoutImgSubmenu: 'layout-A-B-C-D.png', layoutImgDesk: 'desk-Layout-A.png', wallLayout: 'layout-1.png', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 2, value: 'Synergy', apps: ["LP", "CP"], appsTypeId: [1, 2], preview: 'welcome-Preview-B-C-D.png', previewImgSubmenu: '', previewDesk: 'desk-Preview-A.png', layout: 'welcome-Layout-B-C-D.png', layoutImgSubmenu: 'layout-A-B-C-D.png', layoutImgDesk: 'desk-Layout-A.png', wallLayout: 'layout-1.png', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 3, value: 'Plus', apps: ["LP", "LO"], appsTypeId: [1, 3], preview: 'welcome-Preview-B-E-F.png', previewImgSubmenu: '', previewDesk: 'desk-Preview-A.png', layout: 'welcome-Layout-B-E-F.png', layoutImgSubmenu: 'layout-A-B-C-D.png', layoutImgDesk: 'desk-Layout-A.png', wallLayout: 'layout-1.png', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 4, value: 'Elite', apps: ["LP", "LO", "CP", "CO"], appsId: [1, 2, 3, 4], preview: 'welcome-Preview-B-C-D.png', previewImgSubmenu: 'submenu-Preview-B-C-E-F.png', previewDesk: 'desk-Preview-A.png', layout: 'welcome-Layout-B-C-D.png', layoutImgSubmenu: 'submenu-Layout-B-C-E-F.png', layoutImgDesk: 'desk-Layout-A.png', wallLayout: 'layout-1.png', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' }
  ],*/

  packageTypes: [
    { id: 1, value: 'Essential', apps: ["LP"], appsTypeId: [1], preview: 'welcome-Preview-B', previewImgSubmenu: '', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B', layoutImgSubmenu: 'empty', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 2, value: 'Synergy', apps: ["LP", "CP"], appsTypeId: [1, 2], preview: 'welcome-Preview-B-C-D', previewImgSubmenu: '', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-C-D', layoutImgSubmenu: 'empty', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 3, value: 'Plus', apps: ["LP", "LO"], appsTypeId: [1, 3], preview: 'welcome-Preview-B-E-F', previewImgSubmenu: '', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-E-F', layoutImgSubmenu: 'empty', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 4, value: 'Elite', apps: ["LP", "LO", "CP", "CO"], appsTypeId: [1, 2, 3, 4], preview: 'welcome-Preview-B-C-D', previewImgSubmenu: 'submenu-Preview-B-C-E-F', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-C-D', layoutImgSubmenu: 'submenu-Layout-B-C-E-F', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 9, value: 'INFINITY LposCpo', apps: ["LP", "LO", "CP", "CO", "LS"], appsTypeId: [1, 2, 3, 4, 8], preview: 'welcome-Preview-B-C-D', previewImgSubmenu: 'submenu-Preview-B-C-E-F-G', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-C-D', layoutImgSubmenu: 'submenu-Layout-B-C-E-F-G', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 10, value: 'Infinity LpCp', apps: ["LP", "CP"], appsTypeId: [1, 2], preview: 'welcome-Preview-B-C-D', previewImgSubmenu: '', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-C-D', layoutImgSubmenu: 'empty', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 11, value: 'Core Lp', apps: ["LP"], appsTypeId: [1], preview: 'welcome-Preview-B', previewImgSubmenu: '', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B', layoutImgSubmenu: 'empty', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 12, value: 'CORE Lpos', apps: ["LP", "LO", "LS"], appsTypeId: [1, 3, 8], preview: 'welcome-Preview-B-E-F-G', previewImgSubmenu: '', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-E-F-G', layoutImgSubmenu: 'empty', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 13, value: 'Infinity LpoCpo', apps: ["LP", "LO", "CP", "CO"], appsTypeId: [1, 2, 3, 4], preview: 'welcome-Preview-B-C-D', previewImgSubmenu: 'submenu-Preview-B-C-E-F', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-C-D', layoutImgSubmenu: 'submenu-Layout-B-C-E-F', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 14, value: 'Core Lpo', apps: ["LP", "LO"], appsTypeId: [1, 3], preview: 'welcome-Preview-B-E-F', previewImgSubmenu: '', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-E-F', layoutImgSubmenu: 'empty', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 15, value: 'Infinity LpsCp', apps: ["LP", "CP", "LS"], appsTypeId: [1, 2, 8], preview: 'welcome-Preview-B-C-D', previewImgSubmenu: 'submenu-Preview-B-C-E-G', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-C-D', layoutImgSubmenu: 'submenu-Layout-B-C-E-G', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' },
    { id: 16, value: 'Core Lps', apps: ["LP", "LS"], appsTypeId: [1, 8], preview: 'welcome-Preview-B-C-D', previewImgSubmenu: '', previewDesk: 'desk-Preview-A', layout: 'welcome-Layout-B-C-D', layoutImgSubmenu: 'empty', layoutImgDesk: 'desk-Layout-A', wallPreview: 'wall_preview', wallLayout: 'wall_layout', pdfLayout: 'mimesys-pdf.svg', pdfLayoutFoldBrochure: 'bi-fold-brochure.svg' }
  ],


  templates: [
    { id: 1, value: 'Standard' },
    { id: 2, value: 'Bi-fold-brochure' }
  ],
  services: [
    { id: 0, apiName: 'None' },
    { id: 1, apiName: 'Indo' },
    { id: 2, apiName: 'Sivo' },
    { id: 3, apiName: 'CR Surfacing' },
    { id: 4, apiName: 'Wetzlich' },
    { id: 5, apiName: 'Szajna' },
    { id: 6, apiName: 'OptView' },
    { id: 7, apiName: 'K-Optical' },
    { id: 8, apiName: 'Test' }
  ],
  mapsDisplay: [
    { id: 1, value: 'Separated' },
    { id: 2, value: 'Fusion' }
  ],
  additionalMapsDisplay: [
    { id: 1, value: 'None' },
    { id: 2, value: 'All' }
  ],
  enviromentLensPro: [
    { id: 1, value: 'Terrace' },
    { id: 2, value: 'Bosphorus - Beta' },
    { id: 3, value: 'Beach - Stepper'}
  ],
  enviromentLensOffice: [
    { id: 1, value: 'Office' },
    { id: 2, value: 'Office - Stepper' }
  ],
  enviromentLensSvision: [
    { id: 1, value: 'Swimming pool' }
  ],
  enviromentCoachProgre: [
    { id: 1, value: 'Restaurant' },
    { id: 2, value: 'Restaurant - Beta' },
    { id: 3, value: 'Restaurant - Stepper' }
  ],
  enviromentCoachOffice: [
    { id: 1, value: 'Office' },
    { id: 2, value: 'Office - Stepper' }
  ],
  enviromentLauncher: [
    { id: 1, value: 'OpticalStore' },
    { id: 2, value: 'OpticalStore - Beta' },
    { id: 3, value: 'Lobby - Stepper' }
  ],
  enviromentComparison: [
    { id: 1, value: 'Restaurant' },
    { id: 2, value: 'Restaurant - Beta' },
    { id: 3, value: 'Restaurant - Stepper' }
  ]
})


